import { CreditReviewSpec } from 'shared/types/creditReview';

export const REQUEST_CREDIT_REVIEW_SPECS = 'REQUEST_CREDIT_REVIEW_SPECS';
export const REQUEST_CREDIT_REVIEW_SPECS_SUCCESS = 'REQUEST_CREDIT_REVIEW_SPECS_SUCCESS';
export const REQUEST_CREDIT_REVIEW_SPECS_ERROR = 'REQUEST_CREDIT_REVIEW_SPECS_ERROR';

export enum CreditReviewSpecsActionTypes {
  Request = 'REQUEST_CREDIT_REVIEW_SPECS',
  RequestSuccess = 'REQUEST_CREDIT_REVIEW_SPECS_SUCCESS',
  RequestError = 'REQUEST_CREDIT_REVIEW_SPECS_ERROR',
}

type CreditReviewSpecsPayload = CreditReviewSpec[];

export interface RequestCreditReviewSpecsAction {
  type: CreditReviewSpecsActionTypes.Request;
}

export interface RequestCreditReviewSpecsSuccessAction {
  type: CreditReviewSpecsActionTypes.RequestSuccess;
  payload: CreditReviewSpecsPayload;
}

export interface RequestCreditReviewSpecsErrorAction {
  type: CreditReviewSpecsActionTypes.RequestError;
  payload: string;
}

export const requestCreditReviewSpecsAction = (): RequestCreditReviewSpecsAction => {
  return {
    type: CreditReviewSpecsActionTypes.Request,
  };
};

export const requestCreditReviewSpecsSuccessAction = (
  payload: CreditReviewSpecsPayload,
): RequestCreditReviewSpecsSuccessAction => {
  return {
    type: CreditReviewSpecsActionTypes.RequestSuccess,
    payload,
  };
};

export const requestCreditReviewSpecsErrorAction = (
  error: string,
): RequestCreditReviewSpecsErrorAction => {
  return {
    type: CreditReviewSpecsActionTypes.RequestError,
    payload: error,
  };
};

export type Actions =
  | RequestCreditReviewSpecsAction
  | RequestCreditReviewSpecsSuccessAction
  | RequestCreditReviewSpecsErrorAction;
